import { Zap, Clock, MessageCircle, Mail } from "lucide-react";

const RULES = [
  { key: "reg_complete", trigger: "Registration complete", actions: ["Send confirmation email", "Send WhatsApp with join link", "Attach ICS calendar invite"] },
  { key: "payment_failed", trigger: "Payment failed / abandoned", actions: ["Retry nudge email after 10 min", "WhatsApp reminder after 1h"] },
  { key: "reminder_24h", trigger: "24h before start", actions: ["Email reminder", "WhatsApp reminder"] },
  { key: "reminder_1h", trigger: "1h before start", actions: ["Email reminder", "WhatsApp reminder"] },
  { key: "reminder_10min", trigger: "10 min before start", actions: ["WhatsApp last-call"] },
  { key: "no_show_start", trigger: "At meeting start, if not joined", actions: ["'We started!' WhatsApp nudge"] },
  { key: "webinar_ended_attended", trigger: "Webinar ended · attendees", actions: ["Thank you email", "Recording + offer WhatsApp"] },
  { key: "webinar_ended_missed", trigger: "Webinar ended · no-shows", actions: ["Missed-it email", "Recording WhatsApp"] },
  { key: "day1_nurture", trigger: "Day 1 after", actions: ["Follow-up email"] },
  { key: "day3_nurture", trigger: "Day 3 after", actions: ["Case-study email"] },
  { key: "day7_nurture", trigger: "Day 7 after", actions: ["Final offer email"] },
];

export default function Automations() {
  return (
    <div className="space-y-6 vp-fade-up">
      <div>
        <div className="vp-label">Automation</div>
        <h1 className="font-display text-3xl font-bold mt-1">Every trigger. Every action.</h1>
        <p className="text-[#4A4D57] mt-1 text-sm">Default automations run out of the box. Visual builder ships in phase 2.</p>
      </div>
      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
        {RULES.map((r, i) => (
          <div key={r.key} className="vp-glass p-5 vp-fade-up" style={{ animationDelay: `${i * 40}ms` }}>
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 rounded-xl bg-[#0B5CFF]/20 border border-[#0B5CFF]/40 flex items-center justify-center">
                <Zap className="w-4 h-4 text-[#0B5CFF]" strokeWidth={1.5} />
              </div>
              <div>
                <div className="vp-label">Trigger</div>
                <div className="font-display font-semibold text-base">{r.trigger}</div>
              </div>
            </div>
            <div className="vp-divider my-4" />
            <ul className="space-y-2">
              {r.actions.map((a, i2) => (
                <li key={i2} className="flex items-start gap-2 text-sm text-[#0B0D17]">
                  {a.toLowerCase().includes("whatsapp") ? <MessageCircle className="w-4 h-4 mt-0.5 text-[#0B5CFF]" strokeWidth={1.5} />
                    : a.toLowerCase().includes("email") ? <Mail className="w-4 h-4 mt-0.5 text-[#0B5CFF]" strokeWidth={1.5} />
                    : <Clock className="w-4 h-4 mt-0.5 text-[#4A4D57]" strokeWidth={1.5} />}
                  {a}
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </div>
  );
}
